import React, { useEffect, useRef, useState } from "react";
import { ClockIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(n: number): string {
  return n.toString().padStart(2, "0");
}
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ""
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const ref = useRef<number | null>(null);
  useEffect(() => {
    ref.current = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => {
      if (ref.current) window.clearInterval(ref.current);
    };
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-38" data-mp="2zrx6gw53rxd2">
      <span className="font-display font-extrabold text-xl sm:text-2xl leading-none bg-white/10 text-white rounded-lg px-2.5 py-1.5 tabular-nums min-w-[2.75rem] text-center" data-id="element-39" data-mp="2zs6w2im8k2i8">
        {value}
      </span>
      <span className="mt-1 text-[9px] sm:text-[10px] uppercase tracking-wide text-white/60" data-id="element-40" data-mp="1h1clvi8xeusc">
        {label}
      </span>
    </div>;
  return <div className={`inline-flex flex-col items-center gap-2 ${className}`} role="timer" aria-live="off" data-id="element-41" data-mp="171c5o56csusd">
      <div className="flex items-center gap-1.5 text-amber-400 text-xs sm:text-sm font-semibold uppercase tracking-wide" data-id="element-42" data-mp="1ushh8859h0wv">
        <ClockIcon className="h-4 w-4" data-id="element-43" data-mp="1zphm4fqdjxme" />
        La oferta termina en
      </div>
      <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-44" data-mp="1l0lj4x36dasn">
        <Box value={pad(hrs)} label="Hrs" data-id="element-45" data-mp="1q06iv9q65n6f" />
        <span className="font-display font-extrabold text-xl sm:text-2xl text-white/50 -mt-3" data-id="element-46" data-mp="1pyvdj5h2s7d7">
          :
        </span>
        <Box value={pad(mins)} label="Min" data-id="element-47" data-mp="2dnxv6dbpm07p" />
        <span className="font-display font-extrabold text-xl sm:text-2xl text-white/50 -mt-3" data-id="element-48" data-mp="2ih0pwos83fph">
          :
        </span>
        <Box value={pad(secs)} label="Seg" data-id="element-49" data-mp="2sbg2zkkkjayc" />
      </div>
    </div>;
}